export const MD_OFFBOARDING_TRANSLATIONS_NAMESPACE = 'jbp-md-offboarding'

export const TRANSLATION_KEYS = {
  title: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--title`,
  description: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--description`,
  inProgress: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--in-progress`,
  completed: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--completed`,
  rejected: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--rejected`,
  startedDate: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--started-date`,
  completedDate: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--completed-date`,
  rejectedDate: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--rejected-date`,
  createdBy: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--created-by`,
  rejectReason: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--reject-reason`,
  loading: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--loading`,
  loadError: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--load-error`,
  retry: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--retry`,
  viewDetails: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--view-details`,
  reopen: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--reopen`,
  reject: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--reject`,
  rejectTitle: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--reject-title`,
  reopenError: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--reopen-error`,
  start: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--start`,
  creating: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--creating`,
  createError: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--create-error`,
  noPermission: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--no-permission`,
  rejectPrompt: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--reject-prompt`,
  reason: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--reason`,
  rejectError: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--reject-error`,
  cancel: `${MD_OFFBOARDING_TRANSLATIONS_NAMESPACE}--cancel`,
}
